/**
 * fadeInTargets JS
 *
 * @since   1.0.0
 * @package mel
 */

(function($) {
	$(document).ready(function() {

		var $fadeInTargets = $('.fade-in-target');
		var $fadeInTargetRight = $(".fade-in-target-right");
		var $fadeInTargetLeft = $(".fade-in-target-left");
		// sanity check if there are any elements to animate on the page
		if ( $fadeInTargets.length < 1 && $fadeInTargetRight.length < 1 && $fadeInTargetLeft.length < 1 ) {
			return;
		}

		var fadeInTargets = (function() {

			var init = function() {
				var $fadeInTarget = document.querySelectorAll(".fade-in-target");
				for (var i = 0; i < $fadeInTarget.length; i++) {
					new Waypoint({
						element: $fadeInTarget[i],
						handler: function handler(direction) {
							if (direction == "down") {
								TweenMax.to(this.element, 2.5, { opacity: 1, ease: Power3.easeOut });
								TweenMax.from(this.element, 2.5, { yPercent: 25, force3D:true, ease: Power3.easeOut });
							} else if (direction == "up") {
								TweenMax.to(this.element, 0.5, { opacity: 0, ease: Power3.easeOut });
							}
						},
						offset: "90%"
					});
				}

				var $fadeInTargetFromLeft = document.querySelectorAll(".fade-in-target-left");
				for (var j = 0; j < $fadeInTargetFromLeft.length; j++) {
					new Waypoint({
						element: $fadeInTargetFromLeft[j],
						handler: function handler(direction) {
							if (direction == "down") {
								TweenMax.to(this.element, 2.5, { opacity: 1, ease: Power3.easeOut });
								TweenMax.from(this.element, 2.5, { xPercent: -25, force3D:true, ease: Power3.easeOut });
							} else if (direction == "up") {
								TweenMax.to(this.element, 0.5, { opacity: 0, ease: Power3.easeOut });
							}
						},
						offset: "90%"
					});
				}

				var $fadeInTargetFromRight = document.querySelectorAll(".fade-in-target-right");
				for (var k = 0; k < $fadeInTargetFromRight.length; k++) {
					new Waypoint({
						element: $fadeInTargetFromRight[k],
						handler: function handler(direction) {
							if (direction == "down") {
								TweenMax.to(this.element, 2.5, { opacity: 1, ease: Power3.easeOut });
								TweenMax.from(this.element, 2.5, { xPercent: 25, force3D:true, ease: Power3.easeOut });
							} else if (direction == "up") {
								TweenMax.to(this.element, 0.5, { opacity: 0, ease: Power3.easeOut });
							}
						},
						offset: "90%"
					});
				}
			};

			return {
				init: init
			};
		})();

		fadeInTargets.init();

	}); // document.ready
})(jQuery);
